import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetKnownColors extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Known Colors</h1>
				<p>This method returns currently known colors(ex: the column at the far right in this <a href="http://www.bricklink.com/catalogItem.asp?P=3001" target="_blank">page</a>) of the item</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> {`/items/{type}/{no}/colors`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<p>Do not supply a request parameter with this method.</p>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a list of <a href="?page=resource-representations-catalog">known color</a> as "data" in the response body.</p>
			</section>
		);
	}
}